import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import hero from '../assets/images/hero/facturacion.jpg'
import { FiExternalLink } from 'react-icons/fi'
import fact1 from '../assets/images/facturacion/fact1.jpg';
import fact2 from '../assets/images/facturacion/fact2.jpg';
import fact3 from '../assets/images/facturacion/fact3.jpg';
// import fact4 from '../assets/images/facturacion/fact4.jpg';
import { Helmet } from 'react-helmet-async'

export default function Facturacion() {

    const facturacionlink1 = process.env.REACT_APP_FACTURACION_LINK_1;
    const facturacionlink2 = process.env.REACT_APP_FACTURACION_LINK_2;
    const facturacionlink3 = process.env.REACT_APP_FACTURACION_LINK_3;
    // const facturacionlink4 = process.env.REACT_APP_FACTURACION_LINK_4;

    const basedomain = process.env.REACT_APP_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Facturación | Hospital Aranda de La Parra</title>
                <meta name="description" content="Genera y descarga tus comprobantes electrónicos." />
                <meta property="og:title" content="Facturación | Hospital Aranda de La Parra" />
                <meta property="og:description" content="Genera y descarga tus comprobantes electrónicos." />
                <meta property="og:image" content={`${basedomain}${hero}`} />
                <meta property="og:url" content={`${basedomain}/facturacion`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Facturación | Hospital Aranda de La Parra" />
                <meta name="twitter:description" content="Genera y descarga tus comprobantes electrónicos." />
                <meta name="twitter:image" content={`${basedomain}${hero}`} />
                <meta itemprop="name" content="Facturación | Hospital Aranda de La Parra" />
                <meta itemprop="description" content="Genera y descarga tus comprobantes electrónicos." />
                <meta itemprop="image" content={`${basedomain}${hero}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Facturación</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Facturación</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-3 d-none d-md-block">
                            <img src={fact1} className="img-fluid rounded border border-4 shadow" alt="" />
                        </div>
                        <div className="col-9 mb-5 mb-md-0 pb-5 pb-md-4">
                            <h6 className="py-0 my-0">
                                FACTURACIÓN ELECTRÓNICA
                            </h6>
                            <small>Descarga tu factura desde tu casa, oficina o donde te encuentres ubicado soló necesitas tener los siguientes datos: Número de Factura, Serie y RFC.</small>
                            <br />
                            <Link to={facturacionlink1} target='_blank' className=" mt-3 btn btn-success btn-sm mb-3 mx-auto text-center">
                                <FiExternalLink fontSize={'1em'} />
                                <span> Acceder</span>
                            </Link>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-5">
                        <div className="col-3 d-none d-md-block">
                            <img src={fact2} className="img-fluid rounded border border-4 shadow" alt="" />
                        </div>
                        <div className="col-9 mb-5 mb-md-0 pb-5 pb-md-4">
                            <h6 className="py-0 my-0">
                                FACTURACIÓN ESTACIONAMIENTO
                            </h6>
                            <small>Descarga tu factura desde tu casa, oficina o donde te encuentres ubicado sólo necesitas tener los siguientes datos: Tu rfc y contraseña para acceder a nuestro sistema despues ingresa los datos que se te solicitan espera un momento y aparecera tu factura.</small>
                            <br />
                            <Link to={facturacionlink2} target='_blank' className=" mt-3 btn btn-success btn-sm mb-3 mx-auto text-center">
                                <FiExternalLink fontSize={'1em'} />
                                <span> Acceder</span>
                            </Link>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-5">
                        <div className="col-3 d-none d-md-block">
                            <img src={fact3} className="img-fluid rounded border border-4 shadow" alt="" />
                        </div>
                        <div className="col-9 mb-5 mb-md-0 pb-5 pb-md-4">
                            <h6 className="py-0 my-0">
                                FACTURACIÓN PROVEEDORES
                            </h6>
                            <small>Carga tu factura desde tu casa, oficina o donde te encuentres ubicado.</small>
                            <br />
                            <Link to={facturacionlink3} target='_blank' className=" mt-3 btn btn-success btn-sm mb-3 mx-auto text-center">
                                <FiExternalLink fontSize={'1em'} />
                                <span> Acceder</span>
                            </Link>
                        </div>
                    </div>
                    {/* <div className="row justify-content-center mt-5">
                        <div className="col-3 d-none d-md-block">
                            <img src={fact4} className="img-fluid rounded border border-4 shadow" alt="" />
                        </div>
                        <div className="col-9 mb-5 mb-md-0 pb-5 pb-md-4">
                            <h6 className="py-0 my-0">
                                FACTURACIÓN PAGOS ONLINE
                            </h6>
                            <small>Ingresa tu referencia de pago, y en segundos tu factura podras generar</small>
                            <br />
                            <Link to={facturacionlink4} target='_blank' className=" mt-3 btn btn-success btn-sm mb-3 mx-auto text-center">
                                <FiExternalLink fontSize={'1em'} />
                                <span> Acceder</span>
                            </Link>
                        </div>
                    </div> */}
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
